export const phoneNumberFormatting = (phoneNumber) => {
  if (!phoneNumber || phoneNumber === "") return "";

  let phone = phoneNumber?.replace(/[^0-9]/g, "");
  if (phone?.length !== 10) {
    console.error("Invalid phone number", phone);
    return "";
  }
  return (
    "(" +
    phone?.substring(0, 3) +
    ") " +
    phone?.substring(3, 6) +
    "-" +
    phone?.substring(6)
  );
};
